var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7188 18.5469C25.0938 19.2344 25.0938 19.8906 24.7188 20.5156C24.375 21.1406 23.7969 21.4688 22.9844 21.5H3.01562C2.20312 21.4688 1.625 21.1406 1.28125 20.5156C0.90625 19.8906 0.90625 19.2344 1.28125 18.5469L11.2656 1.48438C11.7031 0.828125 12.2812 0.5 13 0.5C13.7188 0.5 14.2969 0.828125 14.7344 1.48438L24.7188 18.5469ZM11.875 6.875V12.875C11.875 13.1875 12 13.4531 12.25 13.6719C12.4688 13.8906 12.7344 14 13.0469 14C13.7031 13.9375 14.0625 13.5625 14.125 12.875V6.875C14.0625 6.1875 13.6875 5.8125 13 5.75C12.3125 5.8125 11.9375 6.1875 11.875 6.875ZM13 18.5C13.4062 18.5 13.75 18.3594 14.0312 18.0781C14.3125 17.7969 14.4531 17.4531 14.4531 17.0469C14.4531 16.6094 14.3125 16.25 14.0312 15.9688C13.75 15.6875 13.4062 15.5469 13 15.5469C12.5938 15.5469 12.25 15.6875 11.9688 15.9688C11.6875 16.25 11.5469 16.6094 11.5469 17.0469C11.5469 17.4531 11.6875 17.7969 11.9688 18.0781C12.25 18.3594 12.5938 18.5 13 18.5Z",
    fill: "#F74F22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4610238a12c1e3a9b92af76591b29e3e.svg";
export { ForwardRef as ReactComponent };